import { makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { findByKey } from '@thalesrc/js-utils';
import React, { useContext } from 'react';
import { useParams } from 'react-router';

import IndicatorWrapper from 'Common/IndicatorWrapper';
import { EnumContext } from 'context/enum.context';

import { VitalSignsContext } from '../../vital-signs.context';
import Action from './Action';
import EditDialog from './EditDialog';

const useStyles = makeStyles(theme => ({
  col: {
    color: 'inherit',
  },
  header: {
    color: 'gray',
    fontWeight: 'bold',
    fontSize: '13px',
  },
}));

export default function ListBodyMeasurement() {
  const { loading, vitalSigns } = useContext(VitalSignsContext);
  const { vitalSignCategoryDefinition } = useContext(EnumContext);
  const { examinationId, nurseOperationId } = useParams<{ examinationId: string; nurseOperationId: string }>();
  const classes = useStyles();
  const sortedVitalSigns = [...vitalSigns].sort((a, b) => {
    const dateA = new Date(`${a.measurementDate}T${a.measurementTime}`);
    const dateB = new Date(`${b.measurementDate}T${b.measurementTime}`);
    return dateB - dateA;
  });
  return (
    <IndicatorWrapper loading={loading} data={vitalSigns} errorMessage="Gösterilecek Vücut Ölçüm Bulunamadı.">
      <TableContainer style={{ marginBottom: '10px' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.header} align="left" style={{ width: '30%' }}>
                Ölçüm Tarihi
              </TableCell>
              <TableCell className={classes.header} align="left" style={{ width: '10%' }}>
                Kan Basıncı(mmHg)
              </TableCell>
              <TableCell className={classes.header} align="left" style={{ width: '5%' }}>
                Nabız(../dk)
              </TableCell>
              <TableCell className={classes.header} align="left" style={{ width: '5%' }}>
                Ateş(℃)
              </TableCell>
              <TableCell className={classes.header} align="left" style={{ width: '5%' }}>
                Solunum(../dk)
              </TableCell>
              <TableCell className={classes.header} align="left" style={{ width: '15%' }}>
                Ölçüm Yapan Kişi
              </TableCell>
              <TableCell className={classes.header} align="left" style={{ width: '25%' }}>
                Açıklama
              </TableCell>
              <TableCell className={classes.header} align="left" style={{ width: '5%' }}>
                İşlemler
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedVitalSigns?.map((item, index) => (
              <TableRow
                style={{
                  color: `${findByKey(vitalSignCategoryDefinition, 'id', item.bloodPressureCategoryDefinitionId)?.color}`,
                  backgroundColor: `${item.examinationId !== examinationId ? 'gainsboro' : null}`,
                }}
                hover
                key={item.id}>
                <TableCell className={classes.col} align="left">
                  {item?.measurementDate?.split('-')?.reverse()?.join('-') + ' ' + item?.measurementTime}
                </TableCell>
                <TableCell className={classes.col} align="left">
                  {item?.systolic +
                    ' - ' +
                    item?.diastolic +
                    ' (' +
                    findByKey(vitalSignCategoryDefinition, 'id', item.bloodPressureCategoryDefinitionId)?.label +
                    ')'}
                </TableCell>
                <TableCell className={classes.col} align="left">
                  {item.pulseRate}
                </TableCell>
                <TableCell className={classes.col} align="left">
                  {item.bodyTemperature}
                </TableCell>
                <TableCell className={classes.col} align="left">
                  {item.respirationRate}
                </TableCell>
                <TableCell className={classes.col} align="left">
                  {item?.userData?.name}
                </TableCell>
                <TableCell className={classes.col} align="left">
                  {item.description}
                </TableCell>
                <TableCell align="left">
                  {item?.examinationId === examinationId ? (
                    <Action data={item} />
                  ) : item?.nurseOperationId === nurseOperationId ? (
                    <Action data={item} />
                  ) : !examinationId && !nurseOperationId ? (
                    <Action data={item} />
                  ) : null}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <EditDialog />
    </IndicatorWrapper>
  );
}
